import React, { useState, useReducer, useEffect } from 'react';
import {
  Paper,
  Chip,
} from '@mui/material';
import {
  VirtualTableState,
  SortingState,
  DataTypeProvider,
  FilteringState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';
import DateRange from '@mui/icons-material/DateRange';
import TimeAgo from 'react-timeago'
import utils from '../utils'
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import ServiceUserListTableProps, { GeoTypeProvider, AccessoWebTypeProvider, DateTypeProvider, IsAdminTypeProvider, IsResellerTypeProvider, KeygenTypeProvider, PasswordHashTypeProvider, ResellerUsernameTypeProvider, RowNumTypeProvider, UsernameTypeProvider, UserCodeTypeProvider, SwNameTypeProvider, UserTypeTypeProvider } from './ServiceUserListTableProps'
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';

// ************************************************************
// ************************************************************
// ************************************************************

const VIRTUAL_PAGE_SIZE = 50;

export const ServiceUserListComponentWrapper = (props) => {
  const { list_type } = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    if (list_type) {
      // Perform rest api call and response handling
      console.log("list_type!!!")
    }
  }, [list_type]);
  return <ServiceUserList 
    list_type={list_type} 
    navigate={navigate} 
    {...props} />
}

// Funzione per gestire il filtro della colonna "user type"
const handleUserTypeFilter = (filters) => {
  const newFilters = [];
  let userTypeFilterValue = null;
  
  // Estrarre il valore del filtro 'u_user_type' e processare gli altri filtri
  filters.forEach(filter => {
    if (filter.columnName === 'u_user_type') {
      newFilters.push(filter);
      userTypeFilterValue = filter.value.toLowerCase();
      // Non aggiungiamo questo filtro direttamente a newFilters
    } else if (
      filter.columnName !== 'is_admin' &&
      filter.columnName !== 'is_reseller' &&
      filter.columnName !== 'is_gas_specialist'
    ) {
      // Aggiungiamo gli altri filtri a newFilters
      newFilters.push(filter);
    }
    // Altrimenti, non aggiungiamo i filtri 'u_is_admin', 'u_is_reseller', 'u_is_gas_specialist' esistenti
  });

  // Basandoci su userTypeFilterValue, aggiungiamo o rimuoviamo i filtri appropriati
  if (userTypeFilterValue !== null) {
    if (userTypeFilterValue.includes('a')) {
      newFilters.push({ columnName: 'is_admin', value: 1, operation: 'equal' });
    }
    if (userTypeFilterValue.includes('r')) {
      newFilters.push({ columnName: 'is_reseller', value: 1, operation: 'equal' });
    }
    if (userTypeFilterValue.includes('g')) {
      newFilters.push({ columnName: 'is_gas_specialist', value: 1, operation: 'equal' });
    }
    // Se una lettera non è inclusa, non aggiungiamo il filtro corrispondente, quindi viene rimosso
  }

  ///console.log("newFilters", newFilters);
  return newFilters;
};

class ServiceUserList extends React.Component {
  constructor(props) {    
    super(props)    
    this.table_props = new ServiceUserListTableProps()
    this.state = {
      current_list_type: undefined,
      tableRows: [],
      tableSkip: 0,
      requestedTableSkip: 0,
      tableTotalRowCount: VIRTUAL_PAGE_SIZE * 2,
      tableLoading: false,
      tableColumnWidths: this.table_props.getTableColumnWidths(null),
      tableFilters: [],
      tableSorting: [{
        columnName: "last_activity_date", // oppure "created_at"
        direction: "desc",
      }],
    }
    // Variabili per memorizzare gli ID dei timeout
    this.filterTimeout = null;
    this.rowsTimeout = null;
    // Bind debounce wrapper
    this.debouncedGetTableRows = this.debouncedGetTableRows.bind(this);
  }

  // Funzione debounce per getTableRows
  debouncedGetTableRows(requestedTableSkip, take) {
    if (this.rowsTimeout) {
      clearTimeout(this.rowsTimeout);
    }
    this.rowsTimeout = setTimeout(() => {
      this.getTableRows(requestedTableSkip, take);
    }, 800);
  }

  async getTableRows(requestedTableSkip, take) {
    await this.setState({ requestedTableSkip: requestedTableSkip })
    await this.setState({ tableLoading: true })
    await AuthService.getServiceUserList(requestedTableSkip, take, this.state.tableSorting[0], this.state.tableFilters).then(data => {
      var i = requestedTableSkip + 1
      data.rows = data.rows.map(row => {
        row.row_num = i++
        return row
      })
      if (data.is_valid) {
        this.setState({
          tableSkip: data.skip, 
          tableRows: data.rows,
          tableLoading: false,
        })
      } else {
        //console.log(data.message)
        this.setState({ tableLoading: false })
      }
    }).catch(e => {
      //console.log(e)
      this.setState({ tableLoading: false })
    })
  }

  async setTableFilters(value) {
    const newFilters = handleUserTypeFilter(value);
    this.setState({ tableFilters: newFilters });
    // Cancella il timeout precedente se esiste
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
    // Imposta un nuovo timeout per il conteggio
    this.filterTimeout = setTimeout(async () => {
      var data = await AuthService.getServiceUserCount(newFilters);
      if (data.is_valid) this.setState({ tableTotalRowCount: data.value });
    }, 800); // Ritardo di 800 millisecondi
    // Debounce anche per la query dei dati
    this.debouncedGetTableRows(0, VIRTUAL_PAGE_SIZE);
  }  
  async componentDidMount() {
    console.log("list_type", this.props.list_type)
    
    await this.setState({ current_list_type: this.props.list_type })

    var tableFilters = [];
    switch (this.props.list_type) {
      case "gasspecialists":
        tableFilters.push({
          columnName: "is_gas_specialist",
          value: "1",
          operation: "equal",
        });
        break;
      case "resellers":
        tableFilters.push({
          columnName: "is_reseller",
          value: "1",
          operation: "equal",
        });
        break;
      case "admins":
        tableFilters.push({
          columnName: "is_admin",
          value: "1",
          operation: "equal",
        });
        break;
      default:
        // nessun filtro
        break;
    }
    this.setState({ tableFilters: tableFilters })
    
    if (this.props.authStatus.completed) {
      await this.setState({ tableColumnWidths: this.table_props.getTableColumnWidths(this.props.authStatus.user) })
      // aggiorno il numero di righe
      var data = await AuthService.getServiceUserCount(this.state.tableFilters)
      if (data.is_valid) this.setState({ tableTotalRowCount: data.value })
    }
  }
  async componentDidUpdate(prevProps) {
    if (this.props.list_type !== this.state.current_list_type) {
      window.location.reload()
    } else if (this.props.authStatus.completed && !prevProps.authStatus.completed) {
      await this.setState({ tableColumnWidths: this.table_props.getTableColumnWidths(this.props.authStatus.user) })
      // aggiorno il numero di righe
      var data = await AuthService.getServiceUserCount(this.state.tableFilters)
      if (data.is_valid) this.setState({ tableTotalRowCount: data.value })
    }
  }
  componentWillUnmount() {
    // Cancella i timeout quando il componente viene smontato
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
    if (this.rowsTimeout) {
      clearTimeout(this.rowsTimeout);
    }
  }
  render() {     
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />        
    if (!(this.props.authStatus.user.is_admin || this.props.authStatus.user.is_reseller)) return <UserAuthRequired notallowed />
    
    var height = "calc(100vh - " + this.props.navbarHeight + ")"
    return (
      <Paper>

        <Grid 
          rows={this.state.tableRows}
          columns={this.table_props.getTableColumns(this.props.authStatus.user)}
          getRowId={row => row.id} >

          <PasswordHashTypeProvider for={[ "is_password_hashed" ]} />
          <RowNumTypeProvider for={[ "row_num" ]} availableFilterOperations={[ 'equal' ]} />
          <AccessoWebTypeProvider for={[ "accesso_web" ]} availableFilterOperations={[ 'equal' ]} />            
          <IsResellerTypeProvider for={[ "is_reseller", "is_gas_specialist" ]} availableFilterOperations={[ 'equal' ]} />
          <IsAdminTypeProvider for={[ "is_admin" ]} availableFilterOperations={[ 'equal' ]} />
          <UsernameTypeProvider for={[ "username" ]} />
          <DateTypeProvider for={[ "created_at", "activated_at", "last_activity_date" ]} />
          <KeygenTypeProvider for={[ "accesso_keygen" ]} availableFilterOperations={[ 'notEqual', 'equal' ]} />        
          <GeoTypeProvider 
            ipAddrField="last_activity_ip_addr" 
            geoField="last_activity_ip_data" 
            for={[ "last_activity_ip_data" ]} />

          <SwNameTypeProvider for={[ 
              "last_activity_program_name",
            ]} />
          <UserTypeTypeProvider 
            for={[ "u_user_type" ]} 
            availableFilterOperations={[
              'equal',
            ]} />
          <UserCodeTypeProvider for={[ 
              "last_activity_user_code",
            ]} />

          <SortingState
            sorting={this.state.tableSorting}
            onSortingChange={value => this.setState({ tableSorting: value })}
            columnExtensions={this.table_props.getTableSortingStateColumnExtensions()} />
          <VirtualTableState 
            loading={this.state.tableLoading}
            totalRowCount={this.state.tableTotalRowCount} 
            pageSize={VIRTUAL_PAGE_SIZE}
            skip={this.state.tableSkip}
            getRows={this.debouncedGetTableRows} />
          <FilteringState
            filters={this.state.tableFilters}
            onFiltersChange={this.setTableFilters.bind(this)}
            columnExtensions={this.table_props.getTableFilteringStateColumnExtensions()} />
          <VirtualTable 
            height={height}
            columnExtensions={this.table_props.getTableColumnExtensions()} />
          <TableColumnResizing
            columnWidths={this.state.tableColumnWidths}
            onColumnWidthsChange={value => this.setState({ tableColumnWidths: value })} />
          <TableHeaderRow showSortingControls />
          <TableFilterRow showFilterSelector />
        </Grid>

        {this.props.authStatus.user.is_admin && (
          <Fab 
            sx={{
              position: "fixed",
              bottom: (theme) => theme.spacing(3),
              right: (theme) => theme.spacing(5),            
            }}
            onClick={() => this.props.navigate("/service/user/add") }
            variant="extended"
            color="primary" 
            aria-label="add" >
            <AddIcon sx={{ mr: 1 }} />
            ADD NEW
          </Fab>
        )}
      </Paper>
    )
  }
}
